import styled from 'styled-components';

export const AnnouncementNewLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  background-color: #ebebeb;
`;

export const H6 = styled.h6``;

export const A = styled.a`
  cursor: pointer;
`;
